// Which picture stands for a device, by the words its record carries —
// iOS DeviceView.swift `iconName(for:)` and DeviceSeat.swift
// `holderIconName`, with their names mapped to SfIcon's ("laptopcomputer"
// is `mac`, "safari" any browser, "pc" a Windows computer). `android` is
// drawn with the Android logo rather than an icon.

const BROWSER_WORDS = ["safari", "chrome", "firefox", "edge", "opera", "browser"];
const ANDROID_WORDS = [
  "android", "samsung", "pixel", "oneplus", "xiaomi", "redmi", "realme",
  "huawei", "oppo", "vivo", "nokia", "motorola",
];

const lower = (value) => (typeof value === "string" ? value.toLowerCase() : "");

/** A record of `users/{uid}/devices`: `safari`, `mac`, `pc`, `ipad`,
 *  `android` or `iphone`. */
export function deviceIconName(device) {
  const d = device || {};
  const systemName = lower(d.systemName);
  const combined = `${lower(d.model)} ${lower(d.deviceName)} ${systemName}`;
  if (BROWSER_WORDS.some((word) => combined.includes(word))) return "safari";
  if (combined.includes("mac")) return "mac";
  // The Windows app writes systemName "Windows".
  if (systemName === "windows") return "pc";
  if (combined.includes("ipad")) return "ipad";
  if (ANDROID_WORDS.some((word) => combined.includes(word))) return "android";
  return "iphone";
}

/** The device holding a free account's seat (`deviceSeats/{uid}` kind). */
export function seatHolderIconName(kind) {
  switch (kind) {
    case "ipad":
      return "ipad";
    case "mac":
      return "mac";
    case "web":
      return "safari";
    case "windows":
      return "pc";
    default:
      return "iphone";
  }
}
